import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { getWaveRoute } from "@/helpers/navigation.helpers";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import WinnerDropBadge from "../winner/WinnerDropBadge";
import WaveDropTime from "../time/WaveDropTime";
interface ParticipationDropHeaderProps {
  readonly drop: ExtendedDrop;
  readonly showWaveInfo: boolean;
}
export default function ParticipationDropHeader(t0) {
  const $ = _c(26);
  const {
    drop,
    showWaveInfo
  } = t0;
  let t1;
  if ($[0] !== drop.author.level) {
    t1 = <UserCICAndLevel level={drop.author.level} size={UserCICAndLevelSize.SMALL} />;
    $[0] = drop.author.level;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `/${drop.author.handle}`;
  let t3;
  if ($[2] !== drop.author.handle || $[3] !== t2) {
    t3 = <p className="tw-text-md tw-mb-0 tw-leading-none tw-font-semibold"><Link onClick={_temp} href={t2} className="tw-no-underline tw-text-iron-200 hover:tw-text-iron-500 tw-transition tw-duration-300 tw-ease-out">{drop.author.handle}</Link></p>;
    $[2] = drop.author.handle;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t3) {
    t4 = <div className="tw-flex tw-items-center tw-gap-x-2">{t1}{t3}</div>;
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="tw-size-[3px] tw-bg-iron-600 tw-rounded-full tw-flex-shrink-0" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== drop.created_at) {
    t6 = <WaveDropTime timestamp={drop.created_at} />;
    $[9] = drop.created_at;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t6) {
    t7 = <div className="tw-flex tw-items-center tw-gap-x-2">{t4}{t5}{t6}</div>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== drop.rank || $[15] !== drop.winning_context?.decision_time) {
    t8 = drop.rank && <WinnerDropBadge rank={drop.rank} decisionTime={drop.winning_context?.decision_time ?? null} />;
    $[14] = drop.rank;
    $[15] = drop.winning_context?.decision_time;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t8) {
    t9 = <div className="tw-flex tw-items-center tw-gap-x-2">{t8}</div>;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== drop.wave || $[20] !== showWaveInfo) {
    t10 = showWaveInfo && drop.wave && (() => {
      const waveMeta = (drop.wave as unknown as {
        chat?: {
          scope?: {
            group?: {
              is_direct_message?: boolean | undefined;
            } | undefined;
          } | undefined;
        } | undefined;
      })?.chat;
      const isDirectMessage = waveMeta?.scope?.group?.is_direct_message ?? false;
      const waveHref = getWaveRoute({
        waveId: drop.wave.id,
        isDirectMessage,
        isApp: false
      });
      return <Link onClick={_temp2} href={waveHref} className="tw-mb-0 tw-text-[11px] tw-leading-0 tw-text-iron-500 hover:tw-text-iron-300 tw-transition tw-duration-300 tw-ease-out tw-no-underline">{drop.wave.name}</Link>;
    })();
    $[19] = drop.wave;
    $[20] = showWaveInfo;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t7 || $[24] !== t9) {
    t11 = <>{t7}{t9}{t10}</>;
    $[22] = t10;
    $[23] = t7;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}
function _temp(e) {
  return e.stopPropagation();
}